import { LOOK_SCENES as SCENES } from "../../scripts/look-scenes.mjs";

export interface LookHotspot {
  x: number;
  y: number;
  label: string;
  category: string;
  productType: string;
  productHandle?: string;
}

export interface LookScene {
  slug: string;
  title: string;
  caption: string;
  image: string;
  article: string;
  hotspots: LookHotspot[];
}

// The data lives in scripts/look-scenes.mjs so the prerendered body can read it.
export const LOOK_SCENES: LookScene[] = SCENES;
